import { Col, Grid, Image, Row, Typography } from 'antd';

import {
	ButtonBorderKomunitasBeranda,
	ButtonBorderKomunitasDetailArtikel,
} from 'src/components/Forms/Button';

import classes from './index.module.less';

const JoinKomunitasDetailArtikelContainer = (props: any) => {
	const { xs } = Grid.useBreakpoint();
	const typeArtikel = props.artikel.type;
	const dataWa = props.waCommunity;
	const prePregnancy = dataWa.filter((item:any) => item.community_group === 'program-hamil');
	const pregnancy = dataWa.filter((item: any) => item.community_group === 'link-group-ph2');
	const postPregnancy = dataWa.filter((item: any) => item.community_group === 'link-group-ph3');

	return (
		<div className={classes['page-body-wrap']}>
			<div className="container" style={{ marginTop: '40px', marginBottom: '40px' }}>
				<div
					className={
						typeArtikel === 'pre-pregnancy'
							? classes.pageheropre
							: typeArtikel === 'pregnancy'
							? classes.pagehero
							: classes.pageheropost
					}
				>
					<Row>
						<Col
							md={14}
							sm={{ span: 14, order: 1 }}
							xs={{ span: 24, order: 1 }}
							lg={14}
							xl={14}
							style={{
								alignContent: 'center',
								justifyContent: 'center',
							}}
						>
							{typeArtikel === 'pre-pregnancy' ? (
								<div style={{ marginLeft: xs ? '20px' : '80px', marginRight: '20px' }}>
									<p className={classes.title1}>
										Saling Dukung dan Berbagi Cerita di Komunitas Program Hamil
									</p>
									<Typography className={classes.paragraph1}>
										Gabung komunitas Hallobumil dan temukan support, edukasi dan inspirasi di setiap
										langkah perjuanganmu
									</Typography>
									<div style={{ marginTop: '10px', marginBottom: '40px' }}>
										<a
											href={prePregnancy[0]?.url}
											target="_blank"
											rel="noopener noreferrer"
											id="komunitas-program-hamil"
										>
											<ButtonBorderKomunitasDetailArtikel
												text={'Gabung Komunitas Program Hamil'}
											></ButtonBorderKomunitasDetailArtikel>
										</a>
									</div>
								</div>
							) : typeArtikel === 'pregnancy' ? (
								<div
									style={{
										marginLeft: xs ? '20px' : '80px',
										marginRight: '20px',
										marginTop: '20px',
									}}
								>
									<p className={classes.title}>
										Nikmati Perjalanan Kehamilan Bersama Bumil Lainnya
									</p>
									<Typography className={classes.paragraph}>
										Gabung dan temui teman, tips, dan cerita inspiratif di komunitas Hallobumil
										untuk lewati masa hamil dengan penuh dukungan
									</Typography>
									<div style={{ marginTop: '10px', marginBottom: '40px' }}>
										<a
											href={pregnancy[0]?.url}
											target="_blank"
											rel="noopener noreferrer"
											id="komunitas-kehamilan">
											<ButtonBorderKomunitasBeranda
												text={'Gabung Komunitas Kehamilan'}
											></ButtonBorderKomunitasBeranda>
										</a>
									</div>
								</div>
							) : (
								<div style={{ marginLeft: xs ? '20px' : '80px', marginRight: '20px' }}>
									<p className={classes.title1}>Tumbuh Bersama di 1000 Hari Pertama Si Kecil</p>
									<Typography className={classes.paragraph1}>
										Komunitas hangat untuk dapatkan tips, cerita inspiratif, dan teman baru pada
										1000 hari pertama si kecil bersama Hallobumil
									</Typography>
									<div style={{ marginTop: '10px', marginBottom: '40px' }}>
										<a
											href={postPregnancy[0]?.url}
											target="_blank"
											rel="noopener noreferrer"
											id="komunitas-tumbuh-kembang">
											<ButtonBorderKomunitasDetailArtikel
												text={'Gabung Komunitas Tumbuh Kembang'}
											></ButtonBorderKomunitasDetailArtikel>
										</a>
									</div>
								</div>
							)}
						</Col>
						<Col
							md={10}
							sm={{ span: 10, order: 2 }}
							xs={{ span: 24, order: 2 }}
							lg={10}
							xl={10}
							style={{
								textAlign: 'center',
								alignContent: 'center',
								justifyContent: 'center',
							}}
						>
							<div
								style={{
									textAlign: 'center',
									alignContent: 'center',
									justifyContent: 'center',
									marginLeft: '10px',
									marginRight: '10px',
								}}
							>
								{typeArtikel === 'pre-pregnancy' ? (
									<Image src="/images/default/prepregnancy.svg" alt="image" preview={false} />
								) : typeArtikel === 'pregnancy' ? (
									<Image src="/images/default/pregnancy.svg" alt="image" preview={false} />
								) : (
									<Image src="/images/default/postpregnancy.svg" alt="image" preview={false} />
								)}
							</div>
						</Col>
					</Row>
				</div>
			</div>
		</div>
	);
};

export default JoinKomunitasDetailArtikelContainer;
